import { Map } from 'immutable';

import { UPDATE_PDF_FILE_REQUEST, UPDATE_PDF_FILE_FAILURE, UPDATE_PDF_FILE_SUCCESS } from './action';

const initialState = Map({
  type: '',
  payload: [],
  data: {},
});

function reducer(state = initialState, action) {
  const { data, type } = action;

  if (type === UPDATE_PDF_FILE_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .setIn(['payload'], [])
      .setIn(['data'], data);
  }

  if (type === UPDATE_PDF_FILE_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === UPDATE_PDF_FILE_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
